import React from 'react';
import { useSelector } from 'react-redux';
import './AppVersion.scss';

const AppVersion = () => {
	const version = useSelector(state => state?.app?.version);

	return <div className='AppVersion'>Version: {version}</div>;
};

export default AppVersion;
